var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "400", persistent: "", lazy: "" },
      model: {
        value: _vm.openDialog,
        callback: function($$v) {
          _vm.openDialog = $$v
        },
        expression: "openDialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "title" }, [
            _vm._v("Are You Sure?")
          ]),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "px-3", attrs: { column: "" } },
            [
              _c("v-flex", [
                _c("p", [
                  _vm._v(
                    '\n          If a load needs to be rescheduled, go back and click "Update Pick Up ETA."\n        '
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "v-flex",
                [
                  _c("v-textarea", {
                    attrs: { label: "Message" },
                    model: {
                      value: _vm.message,
                      callback: function($$v) {
                        _vm.message = $$v
                      },
                      expression: "message"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "accent", loading: _vm.loadingBtn },
                  on: {
                    click: function($event) {
                      return _vm.cancelLoad()
                    }
                  }
                },
                [_vm._v("\n        Cancel Load\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { flat: "", color: "accent" },
                  on: {
                    click: function($event) {
                      _vm.openDialog = false
                    }
                  }
                },
                [_vm._v("Close")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a651131", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a651131","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/CancelLoadDialog.vue
// module id = null
// module chunks = 